import { createFileRoute, SearchSchemaInput } from "@tanstack/react-router";
import { format } from "date-fns";
import { z } from "zod";

import SetCalendar from "@/components/SetCalendar/SetCalendar";

export const CalendarRoute = () => {
  return <SetCalendar />;
};

// type CalendarSearch = {
//   month: string;
//   otherGyms?: string[];
//   type?: ClimbType | 'MISC';
// }

const calendarSearchSchema = z.object({
  month: z
    .string()
    .regex(/^\d{4}-\d{2}$/)
    .optional()
    .default(() => format(new Date(), "yyyy-MM")),
  otherGyms: z.array(z.string().uuid()).optional(),
  type: z.enum(["BOULDER", "LEAD", "MISC"]).optional(),
  assignee: z.string().uuid().optional(),
  createSet: z.optional(z.coerce.boolean()),
  competition: z.string().uuid().optional(),
});

type CalendarSearch = z.infer<typeof calendarSearchSchema>;

export const Route = createFileRoute("/gym/$venueUuid/schedule/calendar")({
  component: CalendarRoute,
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput): CalendarSearch => {
    return calendarSearchSchema.parse(search);
  },
});

export const useCalendarSearchParams = Route.useSearch;
